import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField } from "@mui/material";
import { useMutation, useQueryClient } from "react-query";
import { enqueueSnackbar } from "notistack";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosClient from "../../../../../../../lib/axios";
import PaperDraggable from "../../../../../../../components/PaperDraggable";
import { formatarInputValorMonetário, formatarMonetárioParaNúmero, formatarValorMonetario } from "../../../../../../../helpers/masks";
import { TCuponsDesconto } from "..";
import { IDataListaTitulosReceber } from "../../../../../../../types/api/financeiro/pesquisar-titulos-receber";
import moment, { Moment } from "moment";
import SelectTitulosReceber from "../../../../../../../components/SelectsSimpleApiQuery/SelectTitulosReceber";
import BasicDatePicker from "../../../../../../../components/BasicDatePicker";

export default function DialogEditarCupom({
    open,
    defaultValue,
    handleClose
}: DialogIncluirLancamentoProps) {

    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const [valor, setValor] = useState(formatarValorMonetario(defaultValue.valor));
    const [titulos, setTitulos] = useState<IDataListaTitulosReceber[] | null>(defaultValue.titulos_receber || null);
    const [dataValidade, setDataValidade] = useState<Moment | null>(defaultValue.data_validade ? moment(defaultValue.data_validade) : null);

    //Querys e mutations
    const { mutate: editarCupom, isLoading } = useMutation({
        mutationKey: 'atualizar-cupom',
        mutationFn: (data: TEditarCupomParams) => axiosClient.post(`/financeiro/cupons/atualizar-cupom/${defaultValue.id}`, data),
        onError: (error) => {
            console.error(error)
            enqueueSnackbar('Erro ao editar cupom!', { variant: 'error' });
        },
        onSuccess: () => {
            enqueueSnackbar(`Cupom editado com sucesso!`, { variant: 'success' });
            queryClient.invalidateQueries("pesquisar-cupons");
            navigate("/financeiro/cupons/listar-todos");
            handleClose();
        }
    })


    const onSubmit = () => {
        editarCupom({
            valor: formatarMonetárioParaNúmero(valor),
            titulos: titulos ? titulos.map(item => item.id) : [],
            data_validade: dataValidade ? dataValidade.format("YYYY-MM-DD") : ""
        });
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth={'xs'}
            fullWidth
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Editar cupom</DialogTitle>

            <DialogContent>
                <form onSubmit={onSubmit}>
                     <Stack spacing={2} mt={2}>
                        <TextField
                            label="Valor"
                            value={valor}
                            onChange={(e) => setValor(formatarInputValorMonetário(e.target.value))}
                            fullWidth
                        />
                        <SelectTitulosReceber
                            value={titulos}
                            onChange={(data) => setTitulos(data as IDataListaTitulosReceber[] | null)}
                            extraParams={{ data_recebimento_is_null: true }}
                            multiple
                        />
                        <BasicDatePicker
                            blockPastDates
                            label="Data de Validade"
                            value={dataValidade}
                            onChange={setDataValidade}
                        />

                    </Stack>
                </form>
            </DialogContent>

            <DialogActions>
                <Button
                    variant="text"
                    onClick={handleClose}
                >
                    Fechar
                </Button>
                <Button
                    variant="contained"
                    onClick={onSubmit}
                    disabled={isLoading || !valor}
                >
                    Editar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export interface DialogIncluirLancamentoProps {
    defaultValue: TCuponsDesconto;
    open: boolean;
    handleClose: () => void
}

type TEditarCupomParams = {
    valor: number;
    titulos: string[];
    data_validade: string;
}
